var _ellipse, _path, _path2, _path3, _path4, _circle, _path5, _circle2, _circle3, _circle4, _circle5, _circle6, _path6, _path7, _path8, _line, _line2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraderHomePageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 118,
    viewBox: "0 0 145 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54,
    cy: 55.6726,
    rx: 35,
    ry: 34.0769,
    fill: "#F58120"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.9885 56.2247C65.9885 55.2414 65.9069 54.5239 65.7302 53.7798H54.2402V58.2178H60.9846C60.8487 59.3207 60.1144 60.9816 58.4826 62.0977L58.4598 62.2463L62.0927 64.9965L62.3444 65.021C64.6559 62.9349 65.9885 59.8654 65.9885 56.2247Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2391 67.9173C57.5433 67.9173 60.3171 66.8543 62.3432 65.0207L58.4815 62.0973C57.4481 62.8016 56.0611 63.2932 54.2391 63.2932C51.0029 63.2932 48.2562 61.2071 47.2771 58.3237L47.1336 58.3356L43.356 61.1925L43.3066 61.3267C45.3191 65.2332 49.4527 67.9173 54.2391 67.9173Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2778 58.3238C47.0194 57.5797 46.8699 56.7824 46.8699 55.9586C46.8699 55.1347 47.0194 54.3375 47.2642 53.5934L47.2573 53.4349L43.4324 50.5322L43.3073 50.5904C42.4779 52.2115 42.002 54.0319 42.002 55.9586C42.002 57.8853 42.4779 59.7056 43.3073 61.3267L47.2778 58.3238Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2391 48.624C56.537 48.624 58.0871 49.594 58.971 50.4046L62.4248 47.1093C60.3036 45.1826 57.5433 44 54.2391 44C49.4527 44 45.3191 46.6841 43.3066 50.5906L47.2635 53.5936C48.2562 50.7102 51.0029 48.624 54.2391 48.624Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 124.291,
    cy: 55.7812,
    r: 5,
    transform: "rotate(-39.0785 124.291 55.7812)",
    fill: "#192657"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3105 43.8892L122.884 55.6353L115.882 27.184",
    stroke: "#192657"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.217,
    cy: 28.0334,
    r: 5,
    transform: "rotate(-39.0785 117.217 28.0334)",
    fill: "#1098F7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.0333,
    cy: 44.4233,
    r: 5,
    transform: "rotate(-39.0785 97.0333 44.4233)",
    fill: "#F58120"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 14,
    r: 6,
    fill: "#192657"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 10,
    r: 9.5,
    stroke: "#F58120"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 84.5,
    r: 7,
    stroke: "#1098F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.001 9C113.834 12.1667 164.201 28.2 135.001 67C98.501 115.5 59.001 135.5 34.501 95.5C10.001 55.5 -3.99902 25.5 28.001 27",
    stroke: "#192657",
    strokeWidth: 0.5,
    strokeDasharray: "2 2 2 2 2 2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24 98H1V76",
    stroke: "#192657",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 96V77C7.9 91 18 95.5 22.5 96H3.5Z",
    fill: "#528FF5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 87.4189,
    x2: 58,
    y2: 87.4189,
    stroke: "#192657"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 91.4189,
    x2: 58,
    y2: 91.4189,
    stroke: "#192657"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 2,
    width: 3,
    height: 35,
    fill: "#528FF5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 20,
    width: 3,
    height: 23,
    fill: "#528FF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraderHomePageIcon);
export default __webpack_public_path__ + "static/media/graderHomePageIcon.09651f8ad07f05ba81a4e7c25440a20e.svg";
export { ForwardRef as ReactComponent };